// 批次号下盒子列表
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./CommandIssued.scss";
import BoxServe from "../../../ajax/api/index";
import copy from "copy-to-clipboard";
import { DownloadOutlined } from "@ant-design/icons";
import { Button, Table, Space, message, Drawer, Select, Tooltip, ConfigProvider, Divider, Checkbox } from "antd";
import zh_CN from "antd/es/locale/zh_CN";
import { exportExcel } from "../../../utils/index";
import BatchSearchHead from "./components/BatchSearchHead"; // 搜索区域
import LongShellModel from "../DeviceHome/components/LongShellModel";
import ShortShellModel from "../DeviceHome/components/ShortShellModel";
import UpdateBoxInfoModel from "../DeviceHome/UpdateBoxInfoModel";

const items = [
  {
    key: "2",
    label: "已选盒子",
    value: "1",
  },
  {
    key: "3",
    label: "符合查询条件盒子",
    value: "2",
  },
];

// table 展示项
const tableShowOptions = [
  {
    key: "deviceNo",
    value: "deviceNo",
    label: "设备号",
  },
  {
    key: "machineNo",
    value: "machineNo",
    label: "上游设备号",
  },
  {
    key: "boxId",
    value: "boxId",
    label: "上游BoxId",
  },
  {
    key: "tag",
    value: "tag",
    label: "设备标记",
  },
  {
    key: "remark",
    value: "remark",
    label: "备注",
  },
  {
    key: "command",
    value: "command",
    label: "执行命令",
  },

  {
    key: "resultState",
    value: "resultState",
    label: "执行结果",
  },
  {
    key: "runState",
    value: "runState",
    label: "命令执行状态",
  },
  {
    key: "resultContent",
    value: "resultContent",
    label: "命令执行返回内容",
  },
  {
    key: "runStateName",
    value: "runStateName",
    label: "命令执行过程",
  },
  {
    key: "createTime",
    value: "createTime",
    label: "操作时间",
  },
];
// table 展示项默认选中
const tableShowDefaultValue = ["deviceNo", "machineNo", "boxId", "tag", "remark", "command", "resultState", "runState", "resultContent", "runStateName", "createTime"];
// 已发命令列表
export default function CommandIssued(props) {
  // 提示信息
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const columns = [
    {
      title: "设备号",
      key: "deviceNo",
      dataIndex: "deviceNo",
      width: 200,
    },
    {
      title: "上游设备号",
      key: "machineNo",
      dataIndex: "machineNo",
      width: 300,
    },
    {
      title: "上游boxId",
      key: "boxId",
      dataIndex: "boxId",
      width: 300,
    },
    {
      title: "设备标记",
      key: "tag",
      dataIndex: "tag",
      width: 180,
    },
    {
      title: "备注",
      key: "remark",
      dataIndex: "remark",
      width: 180,
    },
    {
      title: "执行命令",
      dataIndex: "command",
      key: "command",
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <div className="result-content">
            <span className="text-content" style={{ maxWidth: "50px" }}>
              <Tooltip overlayStyle={{ maxWidth: "60%" }} title={record?.command} color={"blue"} key={"blue"}>
                <span>{record?.command}</span>
              </Tooltip>
            </span>
            <span className="text-copy" onClick={() => handleCopy("command", record?.command)}>
              {record?.command !== "" && String(record?.command) !== "null" ? "复制" : ""}
            </span>
          </div>
        </Space>
      ),
    },
    {
      title: "执行结果",
      key: "resultState",
      dataIndex: "resultState",
      width: 90,
    },
    {
      title: "命令执行状态",
      key: "runState",
      dataIndex: "runState",
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <span>{record?.runState === 1 ? "未执行" : record?.runState === null ? "" : "已执行"}</span>
        </Space>
      ),
    },
    {
      title: "命令执行返回内容",
      key: "resultContent",
      dataIndex: "resultContent",
      width: 250,
      render: (_, record) => (
        <Space size="middle">
          <div className="result-content">
            <span className="text-content" style={{ maxWidth: "180px" }}>
              <Tooltip overlayStyle={{ maxWidth: "90%" }} title={record?.resultContent} color={"blue"} key={"blue"}>
                <span>{record?.resultContent}</span>
              </Tooltip>
            </span>
            <span className="text-copy" onClick={(e) => handleCopy(e, record.resultContent)}>
              {record?.resultContent !== "" && String(record?.resultContent) !== "null" ? "复制" : ""}
            </span>
          </div>
        </Space>
      ),
    },
    {
      title: "命令执行过程",
      key: "runStateName",
      dataIndex: "runStateName",
      width: 200,
      render: (_, record) => (
        <Space size="middle">
          <span>{record?.runStateName === 1 ? "未执行" : record?.runStateName}</span>
        </Space>
      ),
    },
    {
      title: "操作时间",
      key: "createTime",
      dataIndex: "createTime",
      width: 160,
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: 180,
      render: (_, record) => (
        <>
          <span className="action-btn" onClick={() => handleSee(record)}>
            查看
          </span>
          <Divider type="vertical" style={{ gap: "5px !important" }} />
          <span className="action-btn" onClick={() => handleEditDeviceTag(record)}>
            修改设备标记
          </span>
        </>
      ),
    },
  ];

  let [tableColumns, setTableColumns] = useState([...columns]);

  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 20,
    current: 1,
    defaultPageSize: 20,
  });

  const [pagination, setPagination] = useState({
    page: tableParams.current,
    limit: 20,
  });

  // 搜索条件
  const [searchParams, setSearchParams] = useState({});

  // 勾选选择
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // 勾选选择的deviceNo集合
  const [deviceNoList, setDeviceNoList] = useState([]);

  const [loading, setLoading] = useState(false);

  let [list, setList] = useState([]);
  // 总条数
  const [total, setTotal] = useState(0);

  // 长期、短期命令选择（全部、已选盒子）
  const [shellList, setShellList] = useState([]);

  // 短期命令弹框
  const [isShortShellModel, setIsShortShellModel] = useState(false);

  // 长期命令弹框
  const [isLongShellModel, setIsLongShellModel] = useState(false);

  // 短期任务命令选择
  const [selectShortVal, setSelectShortVal] = useState("");
  // 长期任务命令选择
  const [selectLongVal, setSelectLongVal] = useState("");

  // 搜索
  const handleSearch = (obj) => {
    setSearchParams(obj);
    setPagination({
      page: 1,
      limit: 20,
    });
    setTableParams({
      page: 1,
      current: 1,
    });
  };

  // 当前点击的盒子
  const [record, setRecord] = useState({});

  const [detailObj, setDetailObj] = useState({});

  // 修改设备标志
  const [updateBoxInfoModel, setUpdateBoxInfoModel] = useState(false);

  // 详情抽屉
  const [open, setOpen] = useState(false);

  // 勾选选择
  const onSelectChange = (newSelectedRowKeys, filters) => {
    const list = filters?.map((item) => item.deviceNo);
    setDeviceNoList(list);

    setSelectedRowKeys(newSelectedRowKeys);
  };

  // 勾选选择
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // 长期命令弹框关闭
  const handleLongShellModelColse = () => {
    setIsLongShellModel(false);
    // setSelectLongVal("");
  };

  // 短期命令弹框关闭
  const handleShortShellModelColse = () => {
    setIsShortShellModel(false);
    // setSelectShortVal("");
  };

  // 短期命令弹框打开
  const handleShortShellModel = (e) => {
    if (selectShortVal === "") {
      return message.warning("请选择");
    }
    if (selectShortVal === "1" && selectedRowKeys?.length <= 0 && selectShortVal !== "all") {
      return message.warning("请选择数据");
    } else if (selectShortVal === "all" || selectShortVal === "2") {
      setShellList([]);
    } else {
      setShellList([...deviceNoList]);
    }

    setIsShortShellModel(true);
  };

  // 长期命令弹框打开
  const handleLongShellModel = (e) => {
    if (selectLongVal === "") {
      return message.warning("请选择");
    }
    if (selectLongVal === "1" && selectedRowKeys?.length <= 0 && selectLongVal !== "all") {
      return message.warning("请选择数据");
    } else if (selectLongVal === "all" || selectLongVal === "2") {
      setShellList([]);
    } else {
      setShellList([...deviceNoList]);
    }
    setIsLongShellModel(true);
  };

  // 长期任务命令选择
  const handleChangeLongSelect = (val) => {
    setSelectLongVal(val);
    setSelectedRowKeys([]);
    setShellList([]);
  };

  // 短期任务命令选择
  const handleChangeShortSelect = (val) => {
    setSelectShortVal(val);
    setSelectedRowKeys([]);
    setShellList([]);
  };

  // 查看
  const handleSee = (record) => {
    setRecord(record);
    setOpen(true);
    getCurrentCommandResult(record);
  };

  // 分页等
  const onChange = (pagination) => {
    const { current, pageSize } = pagination;
    setList([]);
    setPagination({
      page: current,
      limit: pageSize,
    });
    setTableParams({
      page: current,
      current: current,
    });
  };

  // 复制
  const handleCopy = (e, contents) => {
    if (copy(contents)) {
      messageApi.open({
        type: "success",
        content: "复制成功！",
      });
    } else {
      messageApi.open({
        type: "error",
        content: "复制失败！",
      });
    }
  };

  // 获取列表数据
  const getTasklogList = async () => {
    try {
      setLoading(true);
      const { code, data, count } = await BoxServe.getTasklogList({
        ...tableParams,
        batchNo: location.state?.batchNo,
        ...searchParams,
        ...pagination,
      }).finally(() => {
        setLoading(false);
      });
      if (String(code) === "0") {
        setTableParams({
          ...tableParams,
          total: count ? Number(count) : 0,
        });
        setTotal(count ? Number(count) : 0);
        const list = data?.map((item) => {
          return {
            ...item,
            key: item.id,
          };
        });
        setList(list);
      } else {
        messageApi.open({
          type: "warning",
          content: "出错了~",
        });
      }
    } catch (error) {
      // message.error(error.message || error.msg)
      console.log(error);
    }
  };

  // 获取详情
  const getCurrentCommandResult = async ({ id }) => {
    try {
      // setLoading(true);
      const { code, data } = await BoxServe.getCurrentCommandResult(id).finally(() => {
        // setLoading(false);
      });
      if (String(code) === "0") {
        setDetailObj(data);
      } else {
        messageApi.open({
          type: "warning",
          content: "出错了~",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getTasklogList();
  }, [props, searchParams, pagination]);

  const handleExportExcel = () => {
    const batchNo = location.state?.batchNo?.slice(0, 6);
    const name = `${batchNo}批次_${new Date().getTime()}`;
    const sheetHeader = [];
    const sheetFilter = [];
    const columnWidths = [];
    columns?.forEach((item) => {
      let { title, dataIndex, width } = item;
      if (title !== "操作") {
        sheetHeader.push(title);
      }
      sheetFilter.push(dataIndex);
      columnWidths.push(width / 10);
    });
    exportExcel(list, name, sheetHeader, sheetFilter, columnWidths);
  };

  // 修改设备标志
  const handleEditDeviceTag = async (item) => {
    setUpdateBoxInfoModel(true);
    setDeviceNoList([item.deviceNo]);
  };

  // 修改设备标记弹框关闭
  const handleupdateBoxInfoModelClose = () => {
    setUpdateBoxInfoModel(false);
  };

  // 操作table展示项
  const handleTableChange = (checkedValue) => {
    const newList = columns?.filter((item) => checkedValue?.includes(item.key));
    setTableColumns(newList.concat(columns?.slice(-1)));
  };

  // 重置
  const handleReset = () => {
    setTableParams({
      page: 1,
      limit: 20,
      current: 1,
      defaultPageSize: 20,
    });
    setPagination({
      page: 1,
      // current: 1,
      limit: 20,
    });
  };

  return (
    <>
      {contextHolder}
      <div className="command-issued">
        <div className="search-wrap">
          <BatchSearchHead handleSearch={handleSearch} handleReset={handleReset} />
        </div>
        <div className="top">
          <div className="top-left">
            <span className="checked-text">已选择{selectedRowKeys.length || 0}台盒子</span>
            <Space.Compact className="shell-box">
              <Select defaultValue="" options={items} onChange={handleChangeShortSelect} />
              <Button type="primary" onClick={handleShortShellModel}>
                短期任务命令
              </Button>
            </Space.Compact>

            <Space.Compact className="shell-box">
              <Select defaultValue="" options={items} onChange={handleChangeLongSelect} />
              <Button type="primary" onClick={handleLongShellModel}>
                长期任务命令
              </Button>
            </Space.Compact>
          </div>
          <div className="top-right">
            <Space wrap className="operate-btn">
              <Select
                placeholder="请选择展示项"
                status="error"
                style={{
                  width: 200,
                }}
                dropdownRender={() => (
                  <>
                    <Checkbox.Group className="select-checkbox" defaultValue={tableShowDefaultValue} options={tableShowOptions} onChange={handleTableChange} />
                  </>
                )}
              />
              <Button type="dashed" danger icon={<DownloadOutlined />} onClick={handleExportExcel}>
                导出Excel
              </Button>
            </Space>
          </div>
        </div>
        <ConfigProvider locale={zh_CN}>
          <Table
            scroll={{ x: "100%" }}
            filterMultiple
            rowSelection={rowSelection}
            columns={tableColumns}
            dataSource={list}
            loading={loading}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50, 100, 500, 1000, 5000, 10000],
              total,
              ...tableParams,
              showTotal: (total) => {
                return `共 ${total} 条`;
              },
            }}
            onChange={onChange}
          />
        </ConfigProvider>
        {/* 长期命令 */}
        <LongShellModel
          open={isLongShellModel}
          list={shellList}
          batchNo={location.state?.batchNo}
          searchParams={searchParams}
          selectLongVal={selectLongVal}
          handleLongShellModelColse={handleLongShellModelColse}
        />

        {/* 短期命令 */}
        <ShortShellModel
          open={isShortShellModel}
          list={shellList}
          searchParams={searchParams}
          batchNo={location.state?.batchNo}
          selectShortVal={selectShortVal}
          handleShortShellModelColse={handleShortShellModelColse}
        />

        {/* 修改设备标记 */}
        <UpdateBoxInfoModel open={updateBoxInfoModel} list={deviceNoList} getBusinessList={getTasklogList} handleupdateBoxInfoModelClose={handleupdateBoxInfoModelClose} />

        <Drawer title={record.deviceNo + " 盒子执行详情"} width={1000} placement="right" onClose={onClose} open={open} className="drawer-wrap">
          <ul className="content-list">
            <li className="list-item">
              <span className="title">任务批次号:</span>
              <span className="text">{detailObj.batchNo}</span>
            </li>
            <li className="list-item">
              <span className="title">设备号:</span>
              <span className="text">{detailObj.deviceNo}</span>
            </li>
            <li className="list-item">
              <span className="title">执行的命令内容:</span>
              <span className="text">{detailObj.command}</span>
            </li>
            <li className="list-item">
              <span className="title">是否需要自动关闭远程获取命令开关:</span>
              <span className="text">{detailObj.autoClose === 1 ? "是" : "否"}</span>
            </li>
            <li className="list-item">
              <span className="title">是否发送异步命令:</span>
              <span className="text">{detailObj.fastCommand === 1 ? "是" : "否"}</span>
            </li>
            <li className="list-item">
              <span className="title">预估任务完成时间(单位秒):</span>
              <span className="text">{detailObj.finishTime}</span>
            </li>
            <li className="list-item">
              <span className="title">是否长期执行命令:</span>
              <span className="text">{detailObj.longCmd === 1 ? "是" : "否"}</span>
            </li>
            <li className="list-item">
              <span className="title">备注:</span>
              <span className="text">{detailObj.remark}</span>
            </li>
            <li className="list-item">
              <span className="title">执行命令返回内容:</span>
              <span className="text">{detailObj.resultContent}</span>
            </li>
            <li className="list-item">
              <span className="title">执行结果:</span>
              <span className="text">{detailObj.resultState}</span>
            </li>
            <li className="list-item">
              <span className="title">上传结果时间:</span>
              <span className="text">{detailObj.resultTime}</span>
            </li>
            <li className="list-item">
              <span className="title">命令执行过程:</span>
              <span className="text">{detailObj.runState === "1" ? "未执行" : detailObj.runState === "2" ? "已执行" : ""}</span>
            </li>
            <li className="list-item">
              <span className="title">获取命令时间:</span>
              <span className="text">{detailObj.runTime}</span>
            </li>
            <li className="list-item">
              <span className="title">命令执行超时时间(秒):</span>
              <span className="text">{detailObj.timeOut}</span>
            </li>
          </ul>
        </Drawer>
      </div>
    </>
  );
}
